import PropTypes from 'prop-types';

import React from 'react';

class FooterButton extends React.Component {
  static defaultProps = {
    condition: true,
    enabled: true,
  };

  static propTypes = {
    condition: PropTypes.bool,
    className: PropTypes.string,
    enabled: PropTypes.bool,
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
  };

  render() {
    if (this.props.condition) {
      if (this.props.enabled) {
        return <span className={'footer-item ' + (this.props.className || '')} onClick={this.props.onClick}
          data-event-category='User' data-event-action={'footer-' + this.props.label} >
          <i className={this.props.icon + ' footer-item-icon'} />
          {this.props.label}
        </span>;
      }
      return (
        <span className={'footer-item ' + (this.props.className || '')}
              style={{opacity: 0.65, cursor: 'not-allowed'}} >
          <i className={this.props.icon + ' footer-item-icon'} />
          {this.props.label}
        </span>
      );
    }

    return <span />;
  }
}

export default FooterButton;
